import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ERROR_PATH } from '@woolworthsnz/shop';
import {
	FeatureService,
	PaymentInstrumentsService,
	PaymentStoreService,
	ShopperService,
} from '@woolworthsnz/styleguide';
import { ContextResponse, GetPaymentInstrumentsResponse } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class DeliverySubscriptionPaymentResolver {
	constructor(
		private paymentInstrumentsService: PaymentInstrumentsService,
		private paymentStoreServices: PaymentStoreService,
		private router: Router,
		private featureService: FeatureService,
		private shopperService: ShopperService
	) {}

	resolve(): Observable<GetPaymentInstrumentsResponse> {
		let method: keyof PaymentInstrumentsService = 'getSavedInstruments';
		if (
			(this.shopperService.state$.value?.hasActiveDeliverySubscription === false &&
				this.featureService.isFeatureEnabled(ContextResponse.EnabledFeaturesEnum.EnableWPayDeliverySaver)) ||
			(this.shopperService.state$.value?.hasActiveDeliverySubscription === true &&
				this.shopperService.state$.value?.isWPayDeliverySubscription === true)
		) {
			method = 'getWPaySavedInstruments';
		}
		return this.paymentInstrumentsService[method]().pipe(
			tap(
				(res) => {
					this.paymentStoreServices.setInstruments({
						cardInstruments: res.creditCard?.cards || [],
						directDebitEnabled: false,
						lastUsedPaymentType: res.lastUsedPaymentType,
					});
				},
				() => this.router.navigate([ERROR_PATH], { skipLocationChange: true })
			)
		);
	}
}
